// 🔹 Affection Behavioural Scenario Bank

export const AFFECTION_BANK = [

// ------------------------------------
  // AFFECTION 01
  // ------------------------------------

  {
    id: "aff_01",

    dimension: "affection",

    behaviour: "empathy",

    scenario: "friend_upset",

    text: "A friend seems upset but hasn't said why. You usually...",

    options: [
      {
        label: "Ask if they're okay and listen if they want to talk",
        weights: { affection: +2 }
      },
      {
        label: "Check on them later when there's a good opportunity",
        weights: { affection: +1 }
      },
      {
        label: "Give them some space and wait for them to approach you",
        weights: { affection: 0 }
      },
      {
        label: "Assume they'll deal with it on their own",
        weights: { affection: -2 }
      }
    ]
  },

  // ------------------------------------
  // AFFECTION 02
  // ------------------------------------

  {
    id: "aff_02",

    dimension: "affection",

    behaviour: "emotional_support",

    scenario: "poor_result",

    text: "A classmate is disappointed after getting poor results. You usually...",

    options: [
      {
        label: "Encourage them and remind them they can improve",
        weights: { affection: +2 }
      },
      {
        label: "Offer a few ideas that might help next time",
        weights: { affection: +1, thinking: +1 }
      },
      {
        label: "Give them time before saying anything",
        weights: { affection: 0 }
      },
      {
        label: "Assume they'll work it out themselves",
        weights: { affection: -2 }
      }
    ]
  },

  // ------------------------------------
  // AFFECTION 03
  // ------------------------------------

  {
    id: "aff_03",

    dimension: "affection",

    behaviour: "active_listening",

    scenario: "group_discussion",

    text: "During a group discussion, someone shares an idea you hadn't considered. You usually...",

    options: [
      {
        label: "Listen carefully before sharing your own thoughts",
        weights: { affection: +2 }
      },
      {
        label: "Ask questions to understand their idea better",
        weights: { affection: +1, thinking: +1 }
      },
      {
        label: "Share your own opinion straight away",
        weights: { control: +1 }
      },
      {
        label: "Stay quiet unless someone asks you",
        weights: { affection: -2 }
      }
    ]
  },

  // ------------------------------------
  // AFFECTION 04
  // ------------------------------------

  {
    id: "aff_04",

    dimension: "affection",

    behaviour: "patience",

    scenario: "helping_classmate",

    text: "A classmate is taking longer than everyone else to understand something. You usually...",

    options: [
      {
        label: "Patiently help them until they understand",
        weights: { affection: +2 }
      },
      {
        label: "Encourage them while continuing your own work",
        weights: { affection: +1 }
      },
      {
        label: "Finish the work yourself so the group can continue",
        weights: { control: +1 }
      },
      {
        label: "Become frustrated and leave them to figure it out",
        weights: { affection: -2 }
      }
    ]
  },

  // ------------------------------------
  // AFFECTION 05
  // ------------------------------------

  {
    id: "aff_05",

    dimension: "affection",

    behaviour: "service_orientation",

    scenario: "school_volunteers",

    text: "Your school needs volunteers for an activity. You usually...",

    options: [
      {
        label: "Volunteer if you're able to help",
        weights: { affection: +2 }
      },
      {
        label: "Help if your schedule allows",
        weights: { affection: +1 }
      },
      {
        label: "Support in another way if you can't volunteer",
        weights: { thinking: +1 }
      },
      {
        label: "Leave it for others to handle",
        weights: { affection: -2 }
      }
    ]
  },

  // ------------------------------------
  // AFFECTION 06
  // ------------------------------------

  {
    id: "aff_06",

    dimension: "affection",

    behaviour: "conflict_resolution",

    scenario: "group_disagreement",

    text: "Two classmates disagree while working together. You usually...",

    options: [
      {
        label: "Help them understand each other's point of view",
        weights: { affection: +2 }
      },
      {
        label: "Encourage everyone to discuss the issue calmly",
        weights: { affection: +1 }
      },
      {
        label: "Focus on whichever solution works best",
        weights: { thinking: +1 }
      },
      {
        label: "Stay out of the disagreement",
        weights: { affection: -2 }
      }
    ]
  },

  // ------------------------------------
  // AFFECTION 07
  // ------------------------------------

  {
    id: "aff_07",

    dimension: "affection",

    behaviour: "encouragement",

    scenario: "class_presentation",

    text: "A classmate is nervous before giving a presentation. You usually...",

    options: [
      {
        label: "Encourage them and help build their confidence",
        weights: { affection: +2 }
      },
      {
        label: "Wish them well before they begin",
        weights: { affection: +1 }
      },
      {
        label: "Leave them to prepare on their own",
        weights: { affection: 0 }
      },
      {
        label: "Assume they'll be fine without saying anything",
        weights: { affection: -2 }
      }
    ]
  },

  // ------------------------------------
  // AFFECTION 08
  // ------------------------------------

  {
    id: "aff_08",

    dimension: "affection",

    behaviour: "compassion",

    scenario: "personal_challenge",

    text: "A classmate tells you they're going through a difficult time at home. You usually...",

    options: [
      {
        label: "Listen, show understanding and offer support",
        weights: { affection: +2 }
      },
      {
        label: "Listen and suggest someone they could talk to if needed",
        weights: { affection: +1, thinking: +1 }
      },
      {
        label: "Respect their privacy unless they ask for help",
        weights: { affection: 0 }
      },
      {
        label: "Change the subject because it's personal",
        weights: { affection: -2 }
      }
    ]
  }

];